import { AIDetectorProvider } from './ai-detector-context'
import { useBrowserService, useExperimentService, useUserService } from '../../../lib/hooks'
import { AIDetectorDesktop } from './desktop'
import { AIDetectorMobile } from './mobile'
import { Tool } from '@components/tool'
import { AIDetectorUsageModal, AIDetectorFreeUserTrialModal } from './modals'

export const AIDetector = () => {
  const { isMobileOrTablet } = useBrowserService()
  const { isAnonymous } = useUserService().currentUser
  const { isTools2_XWithLoggedInEnabled } = useExperimentService()

  if (isTools2_XWithLoggedInEnabled()) {
    return (
      <Tool
        toolType="aiDetector"
        outputTitle="AI Detection results"
        submitButtonText="Scan for AI"
        maxWordLimit={1500}
        minWordLimit={40}
        anonymousUsageLimit={1}
      />
    )
  }

  return (
    <AIDetectorProvider isAnonymous={isAnonymous} appElementForModal="#__next">
      {isMobileOrTablet ? <AIDetectorMobile /> : <AIDetectorDesktop />}
      <AIDetectorUsageModal />
      <AIDetectorFreeUserTrialModal />
    </AIDetectorProvider>
  )
}
